'use es6';

import { Map as ImmutableMap } from 'immutable';
import FormPreviewRecord, { FormPreviewKeys } from 'FormsUI/lib/FormPreview';
import * as RequestState from 'FormsCommonComponents/lib/RequestState';
import * as Actions from 'FormsUI/actions/FormPreview';
export function formPreview(state = new FormPreviewRecord(), action) {
  switch (action.type) {
    case Actions.UPDATE_FORM_PREVIEW:
      return state.set(FormPreviewKeys.PREFILLED_FIELDS, new ImmutableMap(action.formPreview));
    case Actions.SET_CONTACT_PREVIEW:
      return state.set(FormPreviewKeys.PREVIEW_CONTACT, action.contact);
    case Actions.REQUEST_PREVIEW_RENDER:
      return state.set(FormPreviewKeys.REQUEST_STATE, RequestState.REQUESTED);
    case Actions.SUCCEEDED_PREVIEW_RENDER:
      return state.set(FormPreviewKeys.REQUEST_STATE, RequestState.SUCCEEDED);
    case Actions.FAILED_PREVIEW_RENDER:
      return state.set(FormPreviewKeys.REQUEST_STATE, RequestState.FAILED);
    case Actions.SHOW_VARIANT:
      return state.set(FormPreviewKeys.SHOW_VARIANT, action.variant);
    case Actions.SET_STEP:
      return state.set(FormPreviewKeys.PAGE_STEP, action.payload);
    default:
      return state;
  }
}